const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      width: '100vw',
      overflow: 'hidden',
      color: theme.colors[0],
      padding: '80px 0',
    },
    rootBackground: {
      background: theme.getRgba(theme.colors[2], 0.1),
    },
    content: {
      extend: theme.wrapper,
      position: 'relative',
      zIndex: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 30,
    },
    mediaContainer: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      aspectRatio: '16/9',
      '& img': {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    title: {
      position: 'relative',
      fontFamily: theme.fonts[1],
      fontWeight: 700,
      textTransform: 'uppercase',
      lineHeight: 1.1,
      fontSize: 'calc(15px + 2vw)',
      '& > span': {
        zIndex: 1,
      },
    },
    text: {
      opacity: 0,
      fontSize: 16,
      lineHeight: 1.5,
      zIndex: 1,
      '& ul': {
        listStyleType: 'disc',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        paddingLeft: 20,
      },
      '& li': {
        color: theme.getRgba(theme.colors[0], 0.5),
        '& strong': {
          fontWeight: 700,
          fontSize: 22,
          textTransform: 'uppercase',
          color: theme.colors[0],
        },
      },
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: 30,
    },
  }

  output[theme.mediaInverse.md] = {
  }

  output[theme.mediaInverse.sm] = {
    root: {
      padding: '40px 0',
    },
    title: {
      fontSize: 'calc(14px + 2vw)',
    },
  }

  return output
}

export default style
